(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3294],{

/***/ 90862:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporate-social-responsibility",
      function () {
        return __webpack_require__(32849);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ corporate_social_responsibility; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./styles/SocialResponsibility.module.scss
var SocialResponsibility_module = __webpack_require__(42839);
var SocialResponsibility_module_default = /*#__PURE__*/__webpack_require__.n(SocialResponsibility_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tabs.js
var Tabs = __webpack_require__(85509);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tab.js + 1 modules
var Tab = __webpack_require__(73192);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./components/PST/VideoTestimonials.tsx
var VideoTestimonials = __webpack_require__(55689);
;// CONCATENATED MODULE: ./components/SocialResponsibility.tsx
















const SocialResponsibilityComponent = (props)=>{
    const csrPageData = props.pageData;
    const sliderRef = (0,react.useRef)(null);
    const settings = {
        dotsClass: (SocialResponsibility_module_default()).sliderDots,
        dots: true,
        infinite: true,
        speed: constants/* sliderSpeed.desktopSpeed */.Y$.desktopSpeed,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
    };
    const gallarySettings = {
        dotsClass: (SocialResponsibility_module_default()).sliderDots,
        dots: true,
        infinite: true,
        speed: constants/* sliderSpeed.desktopSpeed */.Y$.desktopSpeed,
        slidesToShow: 5,
        slidesToScroll: 5,
        arrows: true,
        appendDots: (dots)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: `${(SocialResponsibility_module_default()).arrowDot} ${(SocialResponsibility_module_default()).leftArrowContainer}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SocialResponsibility_module_default()).btcircle,
                            onClick: ()=>sliderRef?.current?.slickPrev(),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: "/new-images/left-arrow.svg",
                                height: 17,
                                width: 10,
                                alt: "left-arrow"
                            })
                        })
                    }),
                    dots,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: `${(SocialResponsibility_module_default()).arrowDot} ${(SocialResponsibility_module_default()).rightArrowContainer}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SocialResponsibility_module_default()).btcircle,
                            onClick: ()=>sliderRef?.current?.slickNext(),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                src: "/new-images/right-arrow.svg",
                                height: 17,
                                width: 10,
                                alt: "right-arrow"
                            })
                        })
                    })
                ]
            }),
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    };
    const renderTrustArea = (trustAreaData)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    lg: 6,
                    md: 6,
                    xs: 12,
                    className: "d-block d-sm-none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SocialResponsibility_module_default()).trustAreaImg,
                        children: trustAreaData.image?.length && trustAreaData.image.map((img, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (SocialResponsibility_module_default()).platformDivImg,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: img.url,
                                    alt: img.alternativeText,
                                    width: 200,
                                    height: 200
                                })
                            }, index);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    lg: 6,
                    md: 6,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SocialResponsibility_module_default()).EmpoweringYou,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SocialResponsibility_module_default()).empoweringYouContent,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "mb-4",
                                    children: trustAreaData.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: trustAreaData.description
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "pl-0",
                                    children: trustAreaData.points?.length > 0 && trustAreaData.points.map((areaPoints, index)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "subHeadUlLi",
                                                children: areaPoints
                                            })
                                        }, index);
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    lg: 6,
                    md: 6,
                    xs: 12,
                    className: "d-none d-sm-block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SocialResponsibility_module_default()).trustAreaImg,
                        children: trustAreaData.image?.length && trustAreaData.image.map((img, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (SocialResponsibility_module_default()).platformDivImg,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: img.url,
                                    alt: img.alternativeText,
                                    width: 200,
                                    height: 200
                                })
                            }, index);
                        })
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "socialResponsibility",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SocialResponsibility_module_default()).socialResponsibility,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SocialResponsibility_module_default()).breadcrum,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    className: "text-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                        lg: 7,
                                        md: 10,
                                        xs: 12,
                                        className: (SocialResponsibility_module_default()).centered,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                        style: {
                                                            opacity: 0.5
                                                        },
                                                        href: "/",
                                                        children: "Home"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                        href: "",
                                                        children: " Corporate Social Responsibility "
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (SocialResponsibility_module_default()).abttopContent,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    children: csrPageData.title
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    className: "justify-content-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xl: 9,
                                        lg: 9,
                                        md: 12,
                                        sm: 12,
                                        className: (SocialResponsibility_module_default()).parentMainColumns,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: "parent-mainImg",
                                            className: (SocialResponsibility_module_default()).parentMain,
                                            children: csrPageData.bannerImages?.length > 0 && csrPageData.bannerImages.map((data, index)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (SocialResponsibility_module_default()).imgdiv,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: `${(SocialResponsibility_module_default()).childa} ${(SocialResponsibility_module_default()).childa1}`,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: data.image?.url,
                                                            alt: data.image?.alternativeText,
                                                            width: data.image?.width,
                                                            height: data.image?.height,
                                                            "object-fit": "fill"
                                                        })
                                                    })
                                                }, index);
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    className: "justify-content-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        lg: 9,
                                        md: 9,
                                        sm: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "para mt-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: csrPageData.description
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "totalBenefits",
                    className: (SocialResponsibility_module_default()).totalBenefits,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: "justify-content-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                lg: 9,
                                md: 11,
                                sm: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (SocialResponsibility_module_default()).parentDiv,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: `${(SocialResponsibility_module_default()).childDiv} ${(SocialResponsibility_module_default()).child3}`,
                                            style: {
                                                background: `url(${csrPageData.benefitsSection?.titleBgImage?.url})  no-repeat center`,
                                                backgroundSize: "contain",
                                                borderRadius: "50%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (SocialResponsibility_module_default()).overlay
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: `${(SocialResponsibility_module_default()).content3} ${(SocialResponsibility_module_default()).contentCenter}`,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                            children: csrPageData.benefitsSection?.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: csrPageData.benefitsSection?.subTitle
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (SocialResponsibility_module_default()).benfitsPonits,
                                            children: csrPageData.benefitsSection?.points?.length && csrPageData.benefitsSection.points.map((data, index)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: `${(SocialResponsibility_module_default()).childDiv} ${(SocialResponsibility_module_default()).child1}`,
                                                    style: {
                                                        backgroundColor: data?.pointBgColor || "#FFDCD8"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: `${(SocialResponsibility_module_default()).content1} ${(SocialResponsibility_module_default()).content}`,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                children: data.title
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: data.subTitle
                                                            })
                                                        ]
                                                    })
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "csrIntiative",
                    className: (SocialResponsibility_module_default()).csrIntiative,
                    style: {
                        backgroundColor: `${csrPageData.csrInitiative?.sectionBgColor}`
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: csrPageData.csrInitiative?.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (SocialResponsibility_module_default()).techTabs,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                                        defaultActiveKey: "CurrentYear",
                                        transition: false,
                                        id: "techCapabilityTabs",
                                        className: (SocialResponsibility_module_default()).tabs,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                                eventKey: "CurrentYear",
                                                title: "Current Year",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (SocialResponsibility_module_default()).courseFinder,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (SocialResponsibility_module_default()).techCabMarBott,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "d-none d-sm-block",
                                                                children: csrPageData.csrInitiative?.currentYears?.length && csrPageData.csrInitiative.currentYears.map((data, index)=>{
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (SocialResponsibility_module_default()).contentDiv,
                                                                        children: index % 2 === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                                        xs: 12,
                                                                                        lg: 6,
                                                                                        md: 6,
                                                                                        sm: 6,
                                                                                        className: (SocialResponsibility_module_default()).content,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: (SocialResponsibility_module_default()).courseFinderContent,
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                                    children: data.title
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                    dangerouslySetInnerHTML: {
                                                                                                        __html: data.description
                                                                                                    }
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                                        xs: 12,
                                                                                        lg: 6,
                                                                                        md: 6,
                                                                                        sm: 6,
                                                                                        children: data.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: (SocialResponsibility_module_default()).platformDivImg,
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                                src: data.image?.url,
                                                                                                alt: data.image?.alternativeText,
                                                                                                width: 450,
                                                                                                height: 360
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                                    xs: 12,
                                                                                    lg: 6,
                                                                                    md: 6,
                                                                                    sm: 6,
                                                                                    children: data.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: (SocialResponsibility_module_default()).platformDivImg,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                            src: data.image?.url,
                                                                                            alt: data.image?.alternativeText,
                                                                                            width: 450,
                                                                                            height: 360
                                                                                        })
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                                    xs: 12,
                                                                                    lg: 6,
                                                                                    md: 6,
                                                                                    sm: 6,
                                                                                    className: (SocialResponsibility_module_default()).content,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: (SocialResponsibility_module_default()).courseFinderContent,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                                children: data.title
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                dangerouslySetInnerHTML: {
                                                                                                    __html: data.description
                                                                                                }
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, index);
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "d-block d-sm-none",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                                                    ...settings,
                                                                    children: csrPageData.csrInitiative?.currentYears?.length && csrPageData.csrInitiative.currentYears.map((data, index)=>{
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (SocialResponsibility_module_default()).platformDivImg,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                        src: data.image?.url,
                                                                                        alt: data.image?.alternativeText,
                                                                                        width: 500,
                                                                                        height: 360
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (SocialResponsibility_module_default()).content,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: (SocialResponsibility_module_default()).courseFinderContent,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                                children: data.title
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                dangerouslySetInnerHTML: {
                                                                                                    __html: data.description
                                                                                                }
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }, index);
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            csrPageData.csrInitiative.lastYear && csrPageData.csrInitiative.lastYear.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                                eventKey: "LastYear",
                                                title: "Last Year",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (SocialResponsibility_module_default()).courseFinder,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (SocialResponsibility_module_default()).techCabMarBott,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "d-none d-sm-block",
                                                                children: csrPageData.csrInitiative.lastYear.map((data, index)=>{
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (SocialResponsibility_module_default()).contentDiv,
                                                                        children: index % 2 === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                                        xs: 12,
                                                                                        lg: 6,
                                                                                        md: 6,
                                                                                        sm: 6,
                                                                                        className: (SocialResponsibility_module_default()).content,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: (SocialResponsibility_module_default()).courseFinderContent,
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                                    children: data.title
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                    dangerouslySetInnerHTML: {
                                                                                                        __html: data.description
                                                                                                    }
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                                        xs: 12,
                                                                                        lg: 6,
                                                                                        md: 6,
                                                                                        sm: 6,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: (SocialResponsibility_module_default()).platformDivImg,
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                                src: data.image?.url,
                                                                                                alt: data.image?.alternativeText,
                                                                                                width: 500,
                                                                                                height: 360
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                                    xs: 12,
                                                                                    lg: 6,
                                                                                    md: 6,
                                                                                    sm: 6,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: (SocialResponsibility_module_default()).platformDivImg,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                            src: data.image?.url,
                                                                                            alt: data.image?.alternativeText,
                                                                                            width: 500,
                                                                                            height: 360
                                                                                        })
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                                    xs: 12,
                                                                                    lg: 6,
                                                                                    md: 6,
                                                                                    sm: 6,
                                                                                    className: (SocialResponsibility_module_default()).content,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: (SocialResponsibility_module_default()).courseFinderContent,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                                children: data.title
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                dangerouslySetInnerHTML: {
                                                                                                    __html: data.description
                                                                                                }
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, index);
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "d-block d-sm-none",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                                                    ...settings,
                                                                    children: csrPageData.csrInitiative?.lastYear?.length && csrPageData.csrInitiative.lastYear.map((data, index)=>{
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            children: [
                                                                                data.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (SocialResponsibility_module_default()).platformDivImg,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                        src: data.image?.url,
                                                                                        alt: data.image?.alternativeText,
                                                                                        width: 500,
                                                                                        height: 360
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (SocialResponsibility_module_default()).content,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: (SocialResponsibility_module_default()).courseFinderContent,
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                                                children: data?.title
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                dangerouslySetInnerHTML: {
                                                                                                    __html: data.description
                                                                                                }
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }, index);
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "kcTrustAreas",
                    className: (SocialResponsibility_module_default()).kcTrustAreas,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SocialResponsibility_module_default()).areaContent,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: csrPageData.trustArea?.title
                                    })
                                }),
                                csrPageData.trustArea?.details?.length && csrPageData.trustArea.details.map((trustAreaData, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (SocialResponsibility_module_default()).trustAreaPadding,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                            children: index % 2 === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                        lg: 6,
                                                        md: 6,
                                                        sm: 12,
                                                        xs: 12,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (SocialResponsibility_module_default()).trustAreaImg,
                                                            children: trustAreaData.image?.length && trustAreaData.image.map((img, index)=>{
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (SocialResponsibility_module_default()).platformDivImg,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                        src: img.url,
                                                                        alt: img.alternativeText,
                                                                        width: 200,
                                                                        height: 200
                                                                    })
                                                                }, index);
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                        lg: 6,
                                                        md: 6,
                                                        sm: 12,
                                                        xs: 12,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (SocialResponsibility_module_default()).empoweringYou,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (SocialResponsibility_module_default()).empoweringYouContent,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                        className: "mb-4",
                                                                        children: trustAreaData.title
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: trustAreaData.description
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                        className: "pl-0",
                                                                        children: trustAreaData.points?.length > 0 && trustAreaData.points.map((areaPoints, index)=>{
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                    className: "subHeadUlLi",
                                                                                    children: areaPoints
                                                                                })
                                                                            }, index);
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            }) : renderTrustArea(trustAreaData)
                                        })
                                    }, index);
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "csrGlimpses",
                    className: (SocialResponsibility_module_default()).csrGlimpses,
                    style: {
                        backgroundColor: `${csrPageData.csrGlimpses?.sectionBgColor}`
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "justify-content-center text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    xl: 9,
                                    lg: 9,
                                    sm: 10,
                                    xs: 12,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: csrPageData.csrGlimpses?.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: csrPageData.csrGlimpses?.description
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (SocialResponsibility_module_default()).gallery,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                        ...gallarySettings,
                                        ref: sliderRef,
                                        className: (SocialResponsibility_module_default()).images,
                                        children: csrPageData.csrGlimpses?.imageGalleries?.length && csrPageData.csrGlimpses?.imageGalleries.map((imagesData, index)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (SocialResponsibility_module_default()).sliderDiv,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: `${(SocialResponsibility_module_default()).galleryImages} ${index % 2 === 0 ? (SocialResponsibility_module_default()).even : ""}`,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: imagesData.images?.url,
                                                        alt: imagesData.images?.alternativeText,
                                                        width: 300,
                                                        height: 300
                                                    })
                                                })
                                            }, index);
                                        })
                                    })
                                })
                            })
                        ]
                    })
                }),
                csrPageData.videoTestimonial && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoTestimonials/* default */.Z, {
                    ...csrPageData.videoTestimonial
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (SocialResponsibility_module_default()).testimonials,
                    style: {
                        backgroundColor: `${csrPageData.ceoSection?.sectionBgColor}`
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                md: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                                    id: "testimonials",
                                    className: (SocialResponsibility_module_default()).testimonialbg,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                                        className: (SocialResponsibility_module_default()).cardBody,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                            className: (SocialResponsibility_module_default()).rowPaddingBot,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    sm: 2,
                                                    md: 3,
                                                    xs: 12,
                                                    className: (SocialResponsibility_module_default()).imgFixedBottom,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: csrPageData.ceoSection?.image?.url,
                                                        width: 186,
                                                        height: 186,
                                                        alt: csrPageData.ceoSection?.image?.alternativeText
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                    sm: 10,
                                                    md: 9,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (SocialResponsibility_module_default()).uptag,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: csrPageData.ceoSection?.message
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (SocialResponsibility_module_default()).smalltext,
                                                                children: "- Pankaj Agrawal, Co-Founder & CEO"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var SocialResponsibility = (SocialResponsibilityComponent);

;// CONCATENATED MODULE: ./pages/corporate-social-responsibility.tsx




const CorporateSocialResponsibilityPage = (props)=>{
    const { meta  } = props.pageData;
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#6C48F0");
        customStyle.setProperty("--navbar-menu-color", "#ffffff");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...meta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialResponsibility, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var corporate_social_responsibility = (CorporateSocialResponsibilityPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9882,4706,474,67,9774,2888,179], function() { return __webpack_exec__(90862); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);